import React from "react";

import UserBreadcrumbs from "Components/PucForm/UserBreadCrumbs";

import { Box, Grid } from "@mui/material";

import { useLocation } from "react-router-dom";

const BodyWrapper = ({ children }) => {
  const location = useLocation();
const formTypes=["/wonder-world", "/keysoul-store", "/display-wall"]
  return (
    <Grid rowSpacing={2}>
      {/* {location.pathname.includes("/wonder-world")||location.pathname.includes("/keysoul-store") ||location.pathname.includes("/display-wall")? null : <UserBreadcrumbs />} */}
      {formTypes.some(path => location.pathname.includes(path)) ? null : <UserBreadcrumbs />}

      <Box>{children}</Box>
    </Grid>
  );
};

export default BodyWrapper;
